import { Mic, Pause, Play } from "lucide-react";
import { StyledVoiceMessageBar } from "./index.styled";

interface VoiceMessageBarProps {
  levels: number[];
  isRecording: boolean;
  isPlaying?: boolean;
  elapsedSeconds: number;
  onToggleRecord: () => void;
  onTogglePlayback?: () => void;
  hasRecording: boolean;
}

const formatTime = (seconds: number) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};

const VoiceMessageBar = ({
  levels,
  isRecording,
  isPlaying = false,
  elapsedSeconds,
  onToggleRecord,
  onTogglePlayback,
  hasRecording,
}: VoiceMessageBarProps) => {
  const showPlaybackControls = hasRecording && !isRecording;

  const handleMainButtonClick = () => {
    if (showPlaybackControls && onTogglePlayback) {
      onTogglePlayback();
      return;
    }
    onToggleRecord();
  };

  return (
    <StyledVoiceMessageBar>
      <button
        type="button"
        data-no-drag
        className={`mic-button ${isRecording ? "recording" : ""} ${showPlaybackControls ? "playback" : ""}`}
        onClick={handleMainButtonClick}
        aria-label={
          isRecording
            ? "עצור הקלטה"
            : showPlaybackControls
              ? isPlaying
                ? "השהה"
                : "השמעה"
              : "התחל הקלטה"
        }
      >
        {showPlaybackControls ? (
          isPlaying ? (
            <Pause size={20} strokeWidth={2.5} fill="currentColor" />
          ) : (
            <Play size={20} strokeWidth={2.5} fill="currentColor" />
          )
        ) : (
          <Mic size={22} strokeWidth={2.2} />
        )}
      </button>

      <div className="waveform-area" aria-hidden="true">
        {levels.map((level, i) => (
          <span
            key={i}
            className="wave-bar"
            style={{ height: `${Math.round(level * 100)}%` }}
          />
        ))}
      </div>

      <span className="timer">{formatTime(elapsedSeconds)}</span>

      {!isRecording && !hasRecording && (
        <span className="hint">לחצו להקלטה</span>
      )}

      {showPlaybackControls && !isPlaying && (
        <span className="hint">לחצו להשמעה</span>
      )}
    </StyledVoiceMessageBar>
  );
};

export default VoiceMessageBar;
